import React, { Component, Fragment } from 'react'
import { BrowserRouter } from 'react-router-dom'
import $ from 'jquery'
import { inject } from 'mobx-react'
import { ToastContainer, toast } from 'react-toastify'
import Routes from './Routes'
import { BASE_API } from '../src/utils/consts'
import './Vendor'
import './assets/css/berryrotundafont.css'
import './styles/bootstrap.scss'
import './styles/app.scss'
import 'sweetalert2/src/sweetalert2.scss'
import axios from 'axios'
import pubsub from 'pubsub-js'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import jwt_decode from 'jwt-decode'
import VersionBadge from './components/Common/versionBadge'
import Cookies from 'js-cookie'
import { getDeviceFingerprint } from './utils/deviceFingerprint'
// Disable warning "Synchronous XMLHttpRequest on the main thread is deprecated.."
$.ajaxPrefilter((o) => (o.async = true))

@inject('userStore')
class App extends Component {
  componentDidMount() {
    // Initialize device fingerprinting and setup axios interceptor
    this.setupAxiosInterceptors()
  }

  setupAxiosInterceptors = async () => {
    // Add request interceptor to attach device fingerprint to all requests
    axios.interceptors.request.use(
      async (config) => {
        try {
          // Get device fingerprint
          const fingerprint = await getDeviceFingerprint()
          // Attach fingerprint data as custom headers
          config.headers['X-Device-Fingerprint'] = fingerprint.visitorId
          config.headers['X-Device-Mobile'] = fingerprint.isMobile ? 'true' : 'false'
          config.headers['X-Device-Platform'] = fingerprint.platform
          config.headers['X-Device-Screen'] = fingerprint.screenResolution
          config.headers['X-Device-Touch'] = fingerprint.maxTouchPoints > 0 ? 'true' : 'false'

          return config
        } catch (error) {
          console.error('Error attaching fingerprint to request:', error)
          // Continue with request even if fingerprinting fails
          return config
        }
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  }

  render() {
    const token = localStorage.getItem('token')
    axios.defaults.withCredentials = true
    axios.defaults.baseURL = BASE_API
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status == 401) {
          localStorage.clear()
          Cookies.remove('hrm_auth_token')
          window.location.pathname = '/login'
        } else {
          throw error
        }
      }
    )
    if (token) {
      const decodedToken = jwt_decode(token)
      this.props.userStore.setUserLevel(decodedToken.user_level)
      this.props.userStore.setUserID(decodedToken.user_id)
      this.props.userStore.setAuthenticated(true)
      this.props.userStore.setUserEmail(decodedToken.email)
      this.props.userStore.setStartDate(decodedToken.start_date)
      this.props.userStore.setUserHasBirthday(decodedToken.userHasBirthday)
      this.props.userStore.setPermissionsKeys(decodedToken.permissions_keys)
      axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
    }

    //Redirect to login
    if (!this.props.userStore.isAuthenticated && window.location.pathname !== '/login' && window.location.pathname !== '/passwordReset') {
      window.location.pathname = '/login'
      Cookies.remove('hrm_auth_token')
    }

    if (token && this.props.userStore.isAuthenticated && !this.props.userStore?.permissionsKeys) {
      localStorage.removeItem('token')
      Cookies.remove('hrm_auth_token')
    }
    if (this.props.userStore.isAuthenticated && window.location.pathname === '/') {
      window.location.pathname = '/dashboard'
    }

    pubsub.subscribe('showNotification', (_, data) => {
      let link = ''
      switch (data.type_notif) {
        case 'SALERY_PROCESSED_NOTIFICATION':
          link = '/wages'
          break
        case 'LEAVE_APPROVED_NOTIFICATION':
        case 'LEAVE_REJECTED_NOTIFICATION':
          link = '/leaves/' + data.ref_id
          break
        case 'NEW_LEAVE_NOTIFICATION':
          link = '/manageLeaves/' + this.props.userStore.user_id + '/' + data.ref_id
          break
        case 'CAR_USAGE_APPROVED_NOTIFICATION':
        case 'CAR_USAGE_REJECTED_NOTIFICATION':
          link = '/bookings/' + data.ref_id
          break
        case 'NEW_CAR_USAGE_NOTIFICATION':
          link = '/manageBookings/' + this.props.userStore.user_id + '/' + data.ref_id
          break
        case 'FEED_NOTIFICATION':
          link = '/dashboard'
          break
        case 'ACADEMY_SIDE_BY_SIDE_GROUP_CREATED':
          link = `${TICKETING_APP}/academy/groups/` + data.ref_id
          break
        default:
          link = null
          break
      }

      const content = link ? (
        <a style={{ textDecoration: 'none', color: 'white' }} href={link}>
          {data.message}
        </a>
      ) : (
        data.message
      )

      toast(content, {
        type: data.type,
        position: 'top-right'
      })
    })

    return (
      <Fragment>
        <ToastContainer />
        <BrowserRouter basename='/'>
          <Routes />
        </BrowserRouter>
        <VersionBadge />
      </Fragment>
    )
  }
}

export default DragDropContext(HTML5Backend)(App)
